export class  FavoritePowerBIObjectModel {
  public id: number;
  public userOrGroupId: number;
  public powerBIObjectId: number;

  constructor() {
  }
}
